import React, { useState } from 'react';
import { Button, MenuItem } from '@material-ui/core';
import ApiService from '../../../../api/restApi';
import { COMPONENT_NAMES, SCREEN_NAMES, trackAnalyticsEvent } from '../../../../constants/analyticsMeta';
import axios from 'axios';

interface ManageSubscriptionsProps {
  buttonType: 'link' | 'contained';
  customer_id: string;
  redirect_url: string;
  isMenuItem?: boolean;
  isAnchor?: boolean;
  anchorText?: string;
  isToolsUser?: boolean;
  email?: string;
  isAtPlanDetail?: boolean;
  isAtAvailableCredits?: boolean;
}

const ManageSubscriptions: React.FC<ManageSubscriptionsProps> = ({
  buttonType,
  customer_id,
  redirect_url,
  isMenuItem,
  isAnchor,
  anchorText,
  isToolsUser = false,
  email = '',
  isAtPlanDetail = false,
  isAtAvailableCredits = false,
}) => {
  const [isGeneratingManageSubLink, setIsGeneratingManageSubLink] = useState(false);

  const handleManageSubscription = async () => {
    try {
      if (!customer_id) {
        return '';
      }
      setIsGeneratingManageSubLink(true);
      const payload = {
        customer_id: customer_id,
        redirect_url: redirect_url,
        isToolsUser: isToolsUser,
        email: email,
      };
      trackAnalyticsEvent({
        eventFor: 'button',
        buttonText: '',
        payload: {
          label: 'Clicked on Manage Subscription',
          component_name: COMPONENT_NAMES.contentai_home,
          screen_name: SCREEN_NAMES.contentai_subscription_management,
        },
      });
      if (isToolsUser) {
        const response = await axios.post(
          `${process.env.NEXT_PUBLIC_HOST_URL}/api/join-content-ai/generate-manage-subscription-link`,
          payload
        );
        if (response?.data?.data?.url) {
          window.location.href = response.data.data.url;
        }
      } else {
        const response = await ApiService.post(
          `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/onboarding/generate-manage-subscription-url`,
          payload
        );
        if (response?.data?.url) {
          window.location.href = response.data.url;
        }
      }
    } catch (error) {
      console.error('error: handleManageSubscription', error);
      setIsGeneratingManageSubLink(false);
    }
  };
  if (isToolsUser && isAtPlanDetail) {
    return (
      <p
        className="manage-account-link"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleManageSubscription();
        }}
      >
        {isGeneratingManageSubLink ? 'Redirecting...' : isAtAvailableCredits ? `${anchorText}` : 'Manage Account'}
      </p>
    );
  }

  if (isAnchor) {
    return (
      <>
        {' '}
        <a
          style={{ color: 'black', whiteSpace: 'nowrap' }}
          href="/"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleManageSubscription();
          }}
        >
          <b>{isGeneratingManageSubLink ? 'Redirecting...' : anchorText || 'Manage Subscription'}</b>
        </a>
      </>
    );
  }
  if (isMenuItem) {
    return (
      <MenuItem onClick={handleManageSubscription} style={{ padding: '4px 8px' }}>
        {isGeneratingManageSubLink ? 'Redirecting...' : 'Manage Subscription'}
      </MenuItem>
    );
  }

  return (
    <Button
      variant={buttonType === 'link' ? 'text' : 'contained'}
      color={buttonType === 'link' ? 'default' : 'primary'}
      className={buttonType === 'link' ? 'blue-link-button' : 'primary'}
      onClick={handleManageSubscription}
      disabled={isGeneratingManageSubLink}
    >
      {isGeneratingManageSubLink ? 'Redirecting...' : 'Manage Subscription'}
    </Button>
  );
};

export default ManageSubscriptions;
